import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <p className="text-center text-gray-400">© 2025 YouIngest</p>
      </div>
    </footer>
  );
}

export default Footer; 